module.exports = __webpack_public_path__ + "static/img/bg33.2c719a9c.png";